<template>
  <div class="research">
    <Title :title="title" />
    <div class="swiper">
      <swiper :options="swiperOption" ref="swiper">
        <swiper-slide v-for="item in piclist" :key="item.ID">
          <img :src="'http://donghao.chinadonghao.com/upload/'+item.BIGURL" alt="">
        </swiper-slide>
      </swiper>
      <div class="el-icon-arrow-left"></div>
      <div class="el-icon-arrow-right"></div>
    </div>
    <div class="preview">
      <swiper :options="swiperOption2" ref="preview">
        <swiper-slide v-for="item in piclist" :key="item.ID">
          <img :src="'http://donghao.chinadonghao.com/upload/'+item.BIGURL" alt="">
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import Title from '../../about/Title/Title.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { mapState } from 'vuex'
import { getPicUrl } from '@/util/lang.js'
export default {
  components: {
    Title,
    swiper,
    swiperSlide
  },
  data() {
    return {
      title: {
        cn: '科研中心',
        en: 'Research center'
      },
      swiperOption:{
        navigation: {
          nextEl: '.research .swiper .el-icon-arrow-right',
          prevEl: '.research .swiper .el-icon-arrow-left',
        }
      },
      swiperOption2:{
        slidesPerView: 3,
        spaceBetween: 10,
        watchSlidesVisibility: true,
        on:{
          tap:()=>{
            let index=this.$refs.preview.swiper.clickedIndex;
            this.$refs.swiper.swiper.slideToLoop(index)
          }
        }
      },
      piclist: []
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.$refs.swiper.swiper.thumbs.swiper = this.$refs.preview.swiper;
    })
    this.fetchDate(this.lang)
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  watch: {
    lang: 'fetchDate'
  },
  methods: {
    fetchDate (val) {
      if (val) {
        const url = getPicUrl(this.lang, '科研中心', '100')
        this.$$axios.get(url).then(res => {
          this.piclist = res.data
        })
      }
    }
  }
}
</script>

<style scoped>
.research{
    padding: 50px 100px;
    max-width: 1000px;
    margin: 0 auto;
}
.research .title{
  margin-bottom: 30px;
}
.research .swiper{
  position: relative;
}
.research .swiper img{
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.research .preview{
  position: relative;
  margin-top: 20px;
}
.research .preview img{
  width: 100%;
}
.research .preview .swiper-slide-thumb-active{
  border: 5px solid #005598;
}
.research .swiper .el-icon-arrow-left,.research .swiper .el-icon-arrow-right{
  position: absolute;
  top: 50%;
  margin-top: -35px;
  font-size: 34px;
  line-height: 70px;
  width: 70px;
  height: 70px;
  background-color: #005598;
  border-radius: 50%;
  text-align: center;
  color: #fff;
  z-index: 2;
  cursor: pointer;
  outline: none;
}
.research .swiper .el-icon-arrow-left{
  left: -80px;
}
.research .swiper .el-icon-arrow-right{
  right: -80px;
}
@media (max-width: 768px){
  .research{
    padding-left: 0;
    padding-right: 0;
  }
  .research .swiper .el-icon-arrow-left,
  .research .swiper .el-icon-arrow-right{
    width: 30px;
    height: 30px;
    margin-top: 15px;
    font-size: 16px;
    line-height: 30px;
    display: none;
  }
  .research .swiper .el-icon-arrow-left{
    left: -35px;
  }
  .research .swiper .el-icon-arrow-right{
    right: -35px;
  }
}
</style>


